﻿[<RequireQualifiedAccess>]
module PortalLibs.Shared.Result


let resultOrEmptyList<'T> result : 'T list =
  match result with
  | Error _ -> []
  | Ok list -> list

let resultOrEmptyListIfNone<'T> (opt: Result<'T list, string> option) : 'T list =
  match opt with
  | None -> []
  | Some result -> resultOrEmptyList result
